// src/hooks/usePageLoad.js
import { useState, useEffect } from 'react';

// hooks/usePageLoad.js
export const usePageLoad = (events) => {
    const [isAPILoaded, setIsAPILoaded] = useState(false);
    const [isPageLoaded, setIsPageLoaded] = useState(false);
  
    useEffect(() => {
      const checkLoad = async () => {
        if (events.length > 0) setIsAPILoaded(true);
        
        await document.fonts.ready;
        const images = Array.from(document.images);
        await Promise.all(
          images.map(img => 
            new Promise((resolve) => {
              if (img.complete) resolve();
              else {
                img.onload = resolve;
                img.onerror = resolve;
              }
            })
          )
        );
        setIsPageLoaded(true);
      };
      checkLoad();
    }, [events]);
  
    return { isAPILoaded, isPageLoaded };
  };